// extracted by mini-css-extract-plugin
export default {"small":"KBfTsREOeQOSP3_R3udz","check":"lx1ebDYsTlZhvDDqDtcI","placeHolderShimmer":"nKXbkCOOz34WF1q6bXbw"};